// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/Users/yingben001/IdeaProjects/edatlink-box-admin/src/models/contactData';
import model_2 from '/Users/yingben001/IdeaProjects/edatlink-box-admin/src/models/copilot';
import model_3 from '/Users/yingben001/IdeaProjects/edatlink-box-admin/src/models/message';
import model_4 from '/Users/yingben001/IdeaProjects/edatlink-box-admin/src/pages/ISWAN_APP/FireWatch/models/testLooping';
import model_5 from '/Users/yingben001/IdeaProjects/edatlink-box-admin/src/pages/ISWAN_BASE/AppVersion/models/appList';
import model_6 from '/Users/yingben001/IdeaProjects/edatlink-box-admin/src/pages/ISWAN_CHAT/models/aiType';
import model_7 from '/Users/yingben001/IdeaProjects/edatlink-box-admin/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'contactData', model: model_1 },
model_2: { namespace: 'copilot', model: model_2 },
model_3: { namespace: 'message', model: model_3 },
model_4: { namespace: 'ISWAN_APP.FireWatch.testLooping', model: model_4 },
model_5: { namespace: 'ISWAN_BASE.AppVersion.appList', model: model_5 },
model_6: { namespace: 'ISWAN_CHAT.aiType', model: model_6 },
model_7: { namespace: '@@initialState', model: model_7 },
} as const
